import { api } from "./axiosClient";
import type { ContractCategory } from "../types/contractCategories.types";

export const contractCategoriesApi = {
  searchContractCategories: async (payload: any) => {
    const response = await api.post("/contractCategory/search", payload);
    return response.data;
  },

  createContractCategory: async (data: Partial<ContractCategory>) => {
    const response = await api.post("/contractCategory/create", data);
    return response.data;
  },

  updateContractCategory: async (data: Partial<ContractCategory>) => {
    const response = await api.post("/contractCategory/edit", data);
    return response.data;
  },

  removeContractCategory: async (id: string) => {
    return await api.post("/contractCategory/remove", { id });
  },
};
